module.exports = __webpack_public_path__ + "2bff76ac3bca85c1863a9a024fa3ad2e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-bun-s.png
// module id = 2824
// module chunks = 0